import { makeAutoObservable } from "mobx";
import { IProduct, IProductAddOn, IProductCategory } from ".";
import { ApiResponse, IRootStore } from "..";
import Api from "../../services/api";
import { ApiConfig } from "../../services/api-config";
import _ from "lodash";
import { IProductOffer } from "../productOffer";

export default class ProductStore {
  products: Array<IProduct> = [];
  categories: Array<IProductCategory> = [];
  addOns: Array<IProductAddOn> = [];
  selectedCategoryId: number = 0;
  editProduct: IProduct | null = null;
  isAddOnsRequest: boolean = false;

  private rootStore: IRootStore;

  constructor(rootStore: IRootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  fetchProductCategories = () => {
    // this.rootStore.showLoading("Please wait. Loading products...");
    const url = ApiConfig.REST_URIS.product.allCategories;
    Api.get(url, (res: ApiResponse<IProductCategory[]>) => {
      if (res?.isSuccess && res.data) {
        this.categories = _.sortBy(res.data, ["name"]);
      }
    }).finally(() => {
      // this.rootStore.hideLoading();
    });
  };

  fetchProducts = () => {
    const url = ApiConfig.REST_URIS.product.allProducts;
    Api.get(url, (res: ApiResponse<IProduct[]>) => {
      if (res?.isSuccess && res.data) {
        this.products = _.sortBy(res.data, ["category.name"]);
      }
    });
  };

  fetchProductById = (id: number) => {
    const url = ApiConfig.REST_URIS.product.productById(id);
    Api.get(url, (res: ApiResponse<IProduct>) => {
      if (res?.isSuccess && res.data) {
        this.editProduct = res.data;
      }
    });
  };

  fetchAddOns = (productId: number) => {
    const url = ApiConfig.REST_URIS.product.allAddOns(productId);
    Api.get(url, (res: ApiResponse<IProductAddOn[]>) => {
      if (res?.isSuccess && res.data) {
        this.addOns = res.data;
      }
    });
  };

  setSelectedCategoryId = (catId: number) => {
    this.selectedCategoryId = catId;
  };

  setEditProduct = (prod: IProduct | null, isAddOnsRequest: boolean) => {
    this.editProduct = prod;
    this.isAddOnsRequest = isAddOnsRequest;
    if (isAddOnsRequest) this.addOns = [];
  };

  saveProduct = (prod: IProduct, productImgFile: File, callback: Function) => {
    let formData = new FormData();
    const prodId = (prod.productId ?? "0").toString();
    formData.append("productId", prodId);
    formData.append("productName", prod.productName ?? "");
    formData.append("description", prod.description ?? "");
    formData.append("newCategory", prod.newCategory ?? "");
    formData.append("categoryId", prod.categoryId.toString());
    formData.append("sellPrice", prod.sellPrice.toString());
    formData.append("productImagePath", prod.productImagePath);
    formData.append("productImgFile", productImgFile);

    prod.allergens?.forEach((item, index) => {
      formData.append(
        `allergens[${index}][allergenId]`,
        item.allergenId.toString()
      );
      // formData.append(`allergens[${index}][productId]`, prodId);
    });

    if (prod.productId) {
      Api.put(
        ApiConfig.REST_URIS.product.updateProduct(prod.productId),
        formData,
        (res: ApiResponse<number>) => {
          callback && callback(res?.isSuccess && res.data);
        }
      );
    } else {
      Api.post(
        ApiConfig.REST_URIS.product.createProduct,
        formData,
        (res: ApiResponse<number>) => {
          callback && callback(res?.isSuccess && res.data);
        }
      );
    }
  };

  deleteProduct = (id: number, callback: Function) => {
    const url = ApiConfig.REST_URIS.product.deleteProduct(id);

    Api.delete(url, (res: ApiResponse<number>) => {
      callback && callback(res?.isSuccess && res.data);
    });
  };

  hideProduct = (id: number, canHide: boolean, callback: Function) => {
    const url = ApiConfig.REST_URIS.product.hideProduct(id);

    Api.put(url, { canHide }, (res: ApiResponse<number>) => {
      callback && callback(res?.isSuccess && res.data);
    });
  };

  saveProductAddOns = (
    productId: number,
    addOns: number[],
    callback: Function
  ) => {
    const url = ApiConfig.REST_URIS.product.updateProductAddons(productId);
    Api.put(url, addOns, (res: ApiResponse<number>) => {
      callback && callback(res?.isSuccess && res.data);
    });
  };
}
